import React from 'react';
import { Stack, Typography, icons, Button, IconButton } from "@hiver/hiver-ui-kit"
import { useUserProperties } from '../../../common';


export const CalendlyBanner = ({
    title,
    description,
    link,
    propertyId,
    onScheduleCall=null
}) => {

    const {properties: userProperties, setUserProperty} = useUserProperties()
    const openLink = () => {
        window.open(link, '_blank', 'noopener,noreferrer');
        if(onScheduleCall){
            onScheduleCall()
        }
    }

    const handleClose = () => {
        setUserProperty(propertyId, `${Date.now()}`)
    }


    const lastShownDate  = userProperties[propertyId] ?? null;


    /**
     *  checking for a difference of 24hrs from last shown to current time, is yes then only show the banner
     */

    if(lastShownDate){
        const lastDate = new Date(Number(lastShownDate)).getTime();
        const currentDate = Date.now();
        const diff = (currentDate - lastDate)/(1000*60*60); // in Hrs
         if(diff < 24){
            return null;
         }
    }

    return (
        <Stack sx={{
            padding: '8px 12px',
            backgroundColor: "#fffbe8",
            marginBottom: '10px'
        }}>
            <Stack direction="row" sx={{
                alignItems: 'center',
                justifyContent: 'space-between'
            }}>
                <Stack sx={{gap: '2px'}}>
                    <Typography variant="body2_medium" sx={{color: "gray.gray1"}}>{title}</Typography>
                    <Typography variant="body2" sx={{color: "gray.gray3"}}>{description}</Typography>
                </Stack>

                <Stack direction="row" sx={{alignItems: 'center', gap: '10px'}}>
                    <Button 
                    onClick={openLink}
                    variant="outlined"
                    color="tertiary"
                    size="small"
                    sx={{
                        dispaly:'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        bgcolor: "gray.white"
                    }}>
                        <icons.CalendarTodayOutlinedIcon sx={{fontSize : '16px'}}/>
                        Schedule call
                    </Button>

                    <IconButton onClick={handleClose}>
                        <icons.Close />
                    </IconButton>
                </Stack>
            </Stack>

        </Stack>
    )
}